import { receiptsApi } from '../api/receiptsApi'
import type { SendBulkAnnualReportsRequest } from '../api/receiptsApi'

export const sendBulkAnnualReports = async ({
  year,
  churchId,
}: SendBulkAnnualReportsRequest) => {
  try {
    const response = await receiptsApi.sendBulkAnnualReports({
      year,
      churchId,
    })
    return response.data
  } catch (error) {
    console.error(`Error sending receipt email: `, error)
    throw error
  }
}
